import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

interface Notification {
  notificationId: number;
  category: string;
  text: string;
  createdDateTime: string;
  entityId: number;
  entityType: string;
  fromUserId: number;
  fromUserImage: string;
  isRead: boolean;
  title: string;
  userId: number;
}

@Component({
  selector: 'ark-lib-icon-name',
  templateUrl: './icon-name.component.html',
  styleUrl: './icon-name.component.css',
})
export class IconComponentName {
  @Input() classes = '';
  iconPath!: string;

  private _name = '';
  propositionService: any;
  notificationPosts!: Observable<any[]>;

  @Input() data: any;

  constructor() {}

  get name(): string {
    return this._name;
  }
  @Input() set name(v: string) {
    this._name = v;

    if (v) {
      this.iconPath = `/assets/shared/icons/${v}.svg`;
    }
  }

  ngOnInit() {}
}
